import { TableCell, TableRow } from '../../primitives/table';

type VirtualTableSpacerProps = {
    height: number;
    colSpan: number;
};

export function VirtualTableSpacer({ height, colSpan }: VirtualTableSpacerProps) {
    if (height <= 0) return null;

    return (
        <TableRow>
            <TableCell
                colSpan={colSpan}
                style={{
                    height: `${height}px`,
                    padding: 0,
                    border: 'none',
                }}
            />
        </TableRow>
    );
}
